(function ($) {
  function applyContentMatchHeight() {
    if (typeof $.fn.matchHeight === 'undefined') {
      return;
    }

    $('.content-with-circle-image .text-grid .content-outer h3')
      .matchHeight({ remove: true })
      .matchHeight();

    $('.content-with-circle-image .text-grid .content-outer p')
      .matchHeight({ remove: true })
      .matchHeight();
  }

  $(document).ready(function () {
    if ($('.content-with-circle-image').length > 0) {
      // For each section, mark the first .text-grid active and scope hover handlers
      $('.content-with-circle-image').each(function () {
        var $section = $(this);
        $section.find('.text-grid').first().addClass('active');
        $section.find('.text-grid .content-outer').on('mouseenter', function () {
          $section.find('.text-grid').removeClass('active');
          $(this).parent().addClass('active');
        });
      });

      applyContentMatchHeight();
    }
  });

  var resizeTimer;
  $(window).on('resize', function () {
    if ($('.content-with-circle-image').length === 0) {
      return;
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyContentMatchHeight, 250);
  });

  $(window).on('load', function () {
    if ($('.content-with-circle-image').length > 0) {
      applyContentMatchHeight();
    }
  });
})(jQuery);
